class MlbPlayerConverter {
    constructor(creatorId, dateCreated, leagueID) {
        /**
         * Regex for matching feet & inches format, @see https://regex101.com/r/TpvvDj/3
         *
         * @var string
         */
        this.heightImperialRegex = /([\d\.,]+)[\s]?[feet|foot|ft|\'|′]+[\s]?([\d]+)?[\s]?[inch|inches|in|"|″\.,]?/i;
        this.inchToM = 2.54 / 100;
        this.lbToKg = 0.45359237;

        const currentDate = dateCreated || new Date();
        this.tagTemplate = {
            // TODO - enum
            // @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/playertag.json
            // @see https://bitbucket.org/flightscope/dto-schema/src/master/flightscope/playertag.json
            id: null,
            dateCreated: currentDate.toISOString(),
            dateModified: currentDate.toISOString(),
            creatorID: creatorId || 1,
            leagueID: leagueID || 1,
            externalID: null,
            parameters: {
                // @see https://bitbucket.org/flightscope/dto-schema/src/master/flightscope/playertag-parameter.json
                // @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/playertag-parameter.json
                BatHandedness: null,
                ThrowHandedness: null,
                FirstName: null,
                LastName: null,
                DisplayName: null,
                Number: null,
                Position: [],
                Height: null,
                Weight: null,
                Level: 'Professional',
                Gender: null,
                BirthDate: null,
                // TODO - do we need that ?
                GraduationYear: null,
                School: null,
                Address: null,
                AvatarURL: null,
            }
        };
    }

    convert(player) {
        // TODO - entity
        if (!player || typeof(player) !== 'object') {
            throw new TypeError('player must be an object');
        }

        /** Player exmaple
                "id": 642770,
                "fullName": "Javy Guerra",
                "link": "/api/v1/people/642770",
                "firstName": "Javier",
                "lastName": "Guerra",
                "primaryNumber": "8",
                "birthDate": "1995-09-25",
                "currentAge": 25,
                "birthCity": "David",
                "birthCountry": "Panama",
                "height": "6' 0\"",
                "weight": 185,
                "active": true,
                "primaryPosition": {
                    "code": "1",
                    "name": "Pitcher",
                    "type": "Pitcher",
                    "abbreviation": "P"
                },
                "useName": "Javy",
                "middleName": "Alexis",
                "boxscoreName": "Guerra",
                "gender": "M",
                "nameMatrilineal": "Gomez",
                "isPlayer": true,
                "isVerified": true,
                "pronunciation": "GAIR-uh",
                "mlbDebutDate": "2018-05-04",
                "batSide": {
                    "code": "L",
                    "description": "Left"
                },
                "pitchHand": {
                    "code": "R",
                    "description": "Right"
                },
                "nameFirstLast": "Javy Guerra",
                "nameSlug": "javy-guerra-642770",
                "firstLastName": "Javy Guerra",
                "lastFirstName": "Guerra, Javy",
                "lastInitName": "Guerra, J",
                "initLastName": "J Guerra",
                "fullFMLName": "Javier Alexis Guerra",
                "fullLFMName": "Guerra, Javier Alexis",
                "strikeZoneTop": 3.371,
                "strikeZoneBottom": 1.535
            },
         */

        const tag = this.createTagTemplate();
        if (player.fullName) {
            tag.parameters.DisplayName = player.fullName;
        }
        if (player.firstName) {
            tag.parameters.FirstName = player.firstName;
        }
        if (player.lastName) {
            tag.parameters.LastName = player.lastName;
        }
        if (player.primaryNumber) {
            tag.parameters.Number = player.primaryNumber;
        }
        if (player.height) {
            const height = this.convertHeight(player.height);
            if (height !== null) {
                tag.parameters.Height = height;
            }
        }
        if (player.weight) {
            const weight = this.convertHeight(player.weight);
            if (weight !== null) {
                tag.parameters.Weight = weight;
            }
        }
        if (player.primaryPosition) {
            // TODO - enum
            tag.parameters.Position.push(player.primaryPosition.abbreviation);
        }
        if (player.pitchHand) {
            // TODO - enum
            tag.parameters.ThrowHandedness = player.pitchHand.code;
        }
        if (player.batSide) {
            // TODO - enum
            tag.parameters.BatHandedness = player.batSide.code;
        }
        if (player.birthDate) {
            tag.parameters.BirthDate = player.birthDate;
        }
 
        tag.externalID = player.nameSlug;
        // TODO - this could actually be auto-generated etc, but it brings extra level of complexity
        tag.id = player.id;

        return tag;
    }

    createTagTemplate() {
        const tag = Object.assign({}, this.tagTemplate);
        // nested object and array needs special care here
        tag.parameters = Object.assign({}, tag.parameters);

        return tag;
    }

    convertHeight(ftIn) {
        const height = Number.parseFloat(ftIn);
        if (height && !Number.isNaN(height)) {
            return height;
        }

        if (typeof(ftIn) !== 'string') {
            return null;
        }

        // otherwise let's try to parse it, mlb is using the following format in JSON
        // "height": "6' 0\"",
        const matched = this.heightImperialRegex.exec(ftIn);
        if (!matched) {
            return null;
        }

        return (matched[2] || 0) * this.inchToM + (matched[1] || 0) * 12 * this.inchToM;
    }

    convertWeight(lbs) {
        const weight = Number.parseFloat(lbs);
        if (!weight && !Number.isNaN(weight)) {
            return null;
        }

        return weight * this.lbToKg;
    }
}

export default MlbPlayerConverter;